/**
 * PC_AF_01
 * Importing the component, API and packages
 */
import './Appreciation.css';
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { individualAppreciation, directory, updateAppreciation, postAppreciation } from '../../service/PerformanceAPI';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Loader from '../../StaticComponent/Loader';
import { NotificationTrigger, OnlyNumberSpecialChar } from '../../utils/RegHandling';
import { connect } from 'react-redux';
import { encryptStorage } from '../../constant';
import _ from 'lodash';

function AppreciationForm({ websocket }) {
    const { appreciationId } = useParams();

    const { state } = useLocation();
    const navigate = useNavigate();

    /**
     * PC_AF_2
     * State variables are created
     */

    let dataObj = {
        appreciationId: '',
        appreciationTo: [],
        appreciationBy: '',
        description: '',
        startDate: '',
        endDate: '',
        createdBy: '',
    };

    const [pageMode, setPageMode] = useState(false);
    const [appreciationData, setAppreciationData] = useState(dataObj);
    const [appreciationDataOld, setAppreciationDataOld] = useState(dataObj);

    const [showEmployee, setShowEmployee] = useState([]);
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    const [selectedListValidation, setselectedListValidation] = useState('');
    const [description, setdescription] = useState('');
    const [userDetails, setUserDetails] = useState({});

    const [appreciationByValidation, setappreciationByValidation] = useState('');
    const [emp, setEmp] = useState([]);

    const [startDateValidation, setstartDateValidation] = useState('');
    const [endDateValidation, setendDateValidation] = useState('');
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);
    const [isLoading, setIsLoading] = useState();
    const [disabledCheck, setDisabledCheck] = useState(false);
    const [oldSelectedValue, setOldSelectedValue] = useState([]);

    /**
     * PC_AF_4
     * useEffect is invoked then loadAppreciationData function is called
     */

    useEffect(() => {
        setbreadCrumbsData([
            { title: 'Dashboard', path: '/overview?tab=team', isActive: true },
            { title: 'Team Member', path: '', isActive: true },
            { title: 'Appreciation Form', path: '/appreciation', isActive: false },
        ]);
        if (encryptStorage.getItem('groupid') === '1' || encryptStorage.getItem('groupid') === '2') {
            userDetails.roleId = encryptStorage.getItem('employeeId');
            userDetails.role = encryptStorage.getItem('role') === 'Hr' ? 'Hr Manager' : encryptStorage.getItem('role');
            loadAppreciationData();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);

    useEffect(() => {
        if (pageMode) {
            
            // let data = validation()
            
            

            let isSame = _.isEqual(appreciationData, appreciationDataOld);

            oldSelectedValue.filter((o1) => !selectedPeopleList.some((o2) => o1.value === o2.value)).length > 0
                ? setDisabledCheck(false)
                : isSame
                ? setDisabledCheck(true)
                : setDisabledCheck(false);
            // if (isSame) { setDisabledCheck(true) }
            // else if (!isSame) { setDisabledCheck(false) }
        }
    }, [appreciationData, appreciationDataOld, disabledCheck]);

    /**
     * PC_AF_5, PC_AF_11
     * appreciationId is destructed from useParams and check appreciationId is not null then individualAppreciation function is invoked
     */
    const loadAppreciationData = (e) => {
        
        bind()
        if (appreciationId) {
            setIsLoading(false);
            individualAppreciation({ appreciationId: appreciationId })
                .then((res) => {
                 if (encryptStorage.getItem('employeeId') == res?.data?.ResponseData[0]?.created_by_id) {
                     let arr = [];
                     let list = [];
                     let obj = {
                         value: res.data.ResponseData[0].feedback_to,
                         label: res.data.ResponseData[0].appreciation_to,
                         username: res.data.ResponseData[0].appreciation_to,
                     };
                     list.push(obj);
                     setSelectedPeopleList(list);
                     setOldSelectedValue(list);

                     let individualData = {
                         appreciationId: res.data.ResponseData[0].id,
                         appreciationTo: list,
                         appreciationBy: res.data.ResponseData[0].appreciation_by,
                         description: res.data.ResponseData[0].appreciation,
                         startDate: res.data.ResponseData[0].start_date,
                         endDate: res.data.ResponseData[0].end_date,
                     };
                     setAppreciationDataOld(individualData);
                     setAppreciationData(individualData);
                     setPageMode(true);
                 } else {
                     navigate('/', { state: { hideNav: false } });
                 }
                })
                .catch((error) => console.log(error.message));
        }
        setIsLoading(true);
    };

    /**
     * PC_AF_12
     * @param {*} e has the appreciation to person ID is mapped and stored in state variable selectedPeopleList and emp
     */
    const handleChange = (e) => {
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        e.map((data) => {
            attend.push(data.value);
        });
        setSelectedPeopleList(selectedValue);
        setEmp(attend);
        setAppreciationData({ ...appreciationData, ['appreciationTo']: selectedValue });
    };

    /**
     * PC_AF_22,PC_AF_28
     * directory APImethod is called with employeeId as parameter and each response is stored as object and set into showEmployee State variable
     */
    const bind = async () => {
        let empResult;
        if (userDetails.role == 'Hr Manager') {
            empResult = await directory({});
            
        } else {
            empResult = await directory({ empId: userDetails.roleId });
            
        }
        // empResult = await directory({ empId: userDetails.roleId })
        let samplearray = [];
        let selectedarray = [];
        let temparray = empResult.data.ResponseData.emplist;
        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,
                // img: "/Images/logo-person-user-person-icon.jpg",
                label: temparray[i].emp_name,
                username: temparray[i].emp_name,
            };

            if (state?.empId == temparray[i].emp_id) {
                selectedarray.push(objresponse);
            } else samplearray.push(objresponse);
        }
        setShowEmployee(samplearray);
        if (selectedarray.length > 0) {
            let attend = [];
            selectedarray.map((data) => {
                attend.push(data.value);
            });
            setEmp(attend);
            setSelectedPeopleList(selectedarray);
            setAppreciationData({ ...appreciationData, ['appreciationTo']: selectedarray });
        }
    };

    /**
     * PC_AF_12
     * @param {*} e OnchangeName function is invoked when user change the data
     */
    const OnChangeName = (e) => {
        setAppreciationData({ ...appreciationData, [e.target.name]: e.target.value });
    };

    /**
     * PC_AF_14 validation for form is field is validated
     */
    const Validation = () => {
        //
        let result = true;
        if (selectedPeopleList.length == 0) {
            result = false;
            setselectedListValidation('Appreciation to is required');
        }
        if (appreciationData.appreciationBy.trim() == '') {
            result = false;
            setappreciationByValidation('Appreciation by is required');
        } else {
            let checkregex = OnlyNumberSpecialChar(appreciationData.appreciationBy);
            if (checkregex) {
                result = false;
                setappreciationByValidation('Appreciation by is not valid');
            } else {
                setappreciationByValidation('');
            }
        }
        if (appreciationData.description.trim() == '') {
            result = false;
            setdescription('Appreciation is required');
        } else {
            let checkregex = OnlyNumberSpecialChar(appreciationData.description);
            if (checkregex) {
                result = false;
                setdescription('Appreciation is not valid');
            } else {
                setdescription('');
            }
        }
        if (appreciationData.startDate == '') {
            result = false;
            setstartDateValidation('Start date is required');
        }
        if (appreciationData.endDate == '') {
            result = false;
            setendDateValidation('End date is required');
        } else if (appreciationData.endDate < appreciationData.startDate) {
            result = false;
            setendDateValidation('End date must be greater than Start date');
        }

        return result;

        // if (appreciationData.appreciationBy !== '' && appreciationData.description !== '' && appreciationData.startDate !== ''
        //     && appreciationData.endDate !== '' && !(appreciationData.endDate < appreciationData.startDate) && selectedPeopleList.length > 0) {
        //     return true
        // }
        // else return false
    };

    /**
     * PC_AF_13,PC_AF_21
     * submitClick function is invoked when user click save button
     * pageMode is checked and post/update API is called then based on the response user is redirect to appreciation grid page
     */
    const submitClick = async () => {
        let data = Validation();
        if (data) {
            if (pageMode) {
                let attendees_arr = [];

                selectedPeopleList.map((value) => {
                    attendees_arr.push(value.value);
                });

                appreciationData.appreciationTo = attendees_arr;

                setAppreciationData({ ...appreciationData });
                

                let updateResponse = await updateAppreciation(appreciationData);

                if (updateResponse.data.ResponseData.Message == 'Successfully update') {
                    for (let index = 0; index < attendees_arr.length; index++) {
                        let id = attendees_arr[index]
                        let obj = { title: "Appreciation", message: 'Updated the appreciation', route: '/empappreciation', state: { state: { id: appreciationId } }, to_employee: [id], by: userDetails.roleId }

                        await NotificationTrigger(obj, [id], websocket)
                    }
                    sessionStorage.setItem('appreciationToast', 'updated');
                    navigate('/appreciation', { state: { popUp: 'updated' } });
                }
            } else {
                let postData = {
                    appreciationId: 0,
                    appreciationTo: emp,
                    appreciationBy: appreciationData.appreciationBy,
                    description: appreciationData.description,
                    startDate: appreciationData.startDate,
                    endDate: appreciationData.endDate,
                    createdBy: encryptStorage.getItem('employeeId'),
                };


                let postResponse = await postAppreciation(postData);
                if (postResponse.data.ResponseData.Message == 'Successfully inserted') {
                    for (let index = 0; index < postResponse.data.ResponseData.appreciationId.length; index++) {
                        let id = emp[index];
                        await NotificationTrigger(
                            {
                                title: 'Appreciation',
                                message: 'Created the appreciation for you',
                                route: '/empappreciation',
                                state: { state: { id: `${postResponse.data.ResponseData.appreciationId[index]}` } },
                                to_employee: [id],
                                by: userDetails.roleId,
                            },
                            [id],
                            websocket
                        );
                    }
                    sessionStorage.setItem('appreciationToast', 'inserted');
                    navigate('/appreciation', { state: { popUp: 'inserted' } });
                }
            }
        }
    };

    return (
        <>
            {isLoading ? (
                <div className="body-bg">
                    <div className="coverpic container-fluid mt-5">
                        <div className="row justify-content-center">
                            <div className="col-md-8 p-4 mt-5 bg-white rounded-3">
                                <div>
                                    <BreadCrumbs data={breadCrumbsData} />
                                </div>
                                <p className="font-15 tt-bold goal-form-label">{appreciationId ? 'Edit' : 'New'} Appreciation</p>
                                {/*Form structure starts Here*/}
                                <div className="row mb-3 ">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="goal-title" className="form-label hive-form-label">
                                            Appreciation to <span className="required">*</span>
                                        </label>
                                        {/* <input type="text" className="form-control hive-form-control" id="appreciation-to" placeholder="Select" name="appreciationTo"
                                        value={appreciationData.appreciationTo}
                                        onChange={(e) => { appreciationToArray(e) }} /> */}
                                        <Select
                                            className="dropdown"
                                            name="assigned_to_id"
                                            maxMenuHeight={150}
                                            placeholder="Select"
                                            value={selectedPeopleList}
                                            options={showEmployee} // set list of the data
                                            onChange={(e) => {
                                                setselectedListValidation('');
                                                handleChange(e);
                                            }} // assign onChange function
                                            isMulti
                                            isClearable
                                        />
                                        <label className="text-danger">{selectedListValidation}</label>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="appreciation-by" className="form-label  hive-form-label">
                                            Appreciation By <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="appreciation-by"
                                            placeholder="Enter the name"
                                            name="appreciationBy"
                                            value={appreciationData.appreciationBy}
                                            onChange={(e) => {
                                                setappreciationByValidation('');
                                                OnChangeName(e);
                                            }}
                                        />
                                        <label className="text-danger">{appreciationByValidation}</label>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="appreciation" className="form-label  hive-form-label">
                                            Enter the appreciation <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <textarea
                                            className="form-control custom-comment-box hive-form-control"
                                            id="appreciation"
                                            placeholder="Enter the appreciation"
                                            rows={3}
                                            defaultValue={''}
                                            name="description"
                                            value={appreciationData.description}
                                            maxLength={1000}
                                            onChange={(e) => {
                                                setdescription('');
                                                OnChangeName(e);
                                            }}
                                        />
                                        <label className="text-danger">{description}</label>
                                    </div>
                                    <div className="row">
                                        <p className="bold-text font-15 touchbase-form-label mb-2">Timeline</p>

                                        <div className="col-md-3">
                                            <label className="form-label hive-form-label">
                                                Start Date <span className="required">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control hive-form-control"
                                                name="startDate"
                                                onChange={(e) => {
                                                    setstartDateValidation('');
                                                    OnChangeName(e);
                                                }}
                                                value={appreciationData.startDate}
                                            />
                                            <label className="text-danger">{startDateValidation}</label>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label hive-form-label">
                                                End Date <span className="required">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control hive-form-control"
                                                name="endDate"
                                                onChange={(e) => {
                                                    setendDateValidation('');
                                                    OnChangeName(e);
                                                }}
                                                value={appreciationData.endDate}
                                            />
                                            <label className="text-danger">{endDateValidation}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 d-flex justify-content-end">
                                    <Link style={{ textDecoration: 'none' }} to={'/appreciation'}>
                                        <button className="btn  hive-btn-secondary me-2">Cancel</button>
                                    </Link>
                                    <button
                                        disabled={disabledCheck}
                                        className="btn  hive-btn-primary"
                                        onClick={() => {
                                            submitClick();
                                        }}
                                    >
                                        {pageMode ? `Republish` : `Publish`}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <Loader isLoading={isLoading} />
            )}
        </>
    );
}

function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(AppreciationForm);
